const translations = new Map<string, string>();
const TRANSLATIONS_REGEX = /(\r?\n)+/g;
const SCRIPT_SELECTOR = 'script[type="application/json+i18n"]';

export function getTranslation(key: string): string | null {
  return translations.get(key.toLowerCase()) ?? null;
}

export function addTranslation(key: string, value: string): void {
  // Decode any html entities
  const $textarea = document.createElement('textarea');
  $textarea.innerHTML = value;

  translations.set(key.toLowerCase(), $textarea.value);
}

export function addTranslations(items: Record<string, string>): void;
export function addTranslations(items: ArrayLike<[string, string]>): void;
export function addTranslations(items: Record<string, string> | ArrayLike<[string, string]>): void {
  const entries: [string, string][] = !Array.isArray(items)
      ? Object.entries(items)
      : items;

  for (let [key, value] of entries) {
    addTranslation(key, value);
  }
}

export function preloadTranslations(): void {
  const $scripts = document.querySelectorAll(SCRIPT_SELECTOR);

  $scripts.forEach(($script) => {
    const text = $script.textContent ?? '';
    const source = text.trim();

    if (!source.length) {
      return;
    }

    // Parse content (key=value)
    const lines = source.split(TRANSLATIONS_REGEX);

    lines.forEach(line => {
      const [key, value] = line.split('=', 2)
          .map(x => x.trim());

      if (key?.length && value != null) {
        addTranslation(key, value);
      }
    });

    // Release node from DOM
    $script.parentNode?.removeChild($script);
  });
}
